import configClient from "../../api/hooks/config-client"

export const baseURL = "https://vde8-tibi-2023.code.testversion.online/"

export const apiBaseURL = configClient.apiClientBaseURL
export const release = configClient.release
console.log("Release: ", release)

export const translations: {
    [key: string]: {
        [sprache: string]: string
    }
} = {
    Alle: { en: "All" },
    Fotos: { en: "Photos" },
    Videos: { en: "Videos" },
    Dokumente: { en: "Documents" },
    Karten: { en: "Maps" },
    "/de/infothek/mediathek": { en: "/en/infotheque/medialibrary" },
}
